import type { ReactNode } from "react";

import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";

export const hint = "m-0 text-sm leading-6 text-muted-foreground";
export const dash = "—";

/** A section of the page: a card with a title, the runbooks that belong to it, and the body. */
export function Section({
  id,
  titleId,
  title,
  runbookLinks,
  children,
}: Readonly<{
  id: string;
  titleId: string;
  title: string;
  runbookLinks: ReactNode;
  children: ReactNode;
}>) {
  return (
    <section id={id} aria-labelledby={titleId}>
      <Card>
        <CardHeader className="flex flex-row flex-wrap items-center justify-between gap-x-4 gap-y-1">
          <CardTitle id={titleId} className="text-2xl leading-[30px]">
            {title}
          </CardTitle>
          <div className="flex flex-wrap items-center gap-x-4">{runbookLinks}</div>
        </CardHeader>
        <CardContent>{children}</CardContent>
      </Card>
    </section>
  );
}
